import React, { useEffect,  useState } from "react";

import { Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import FASParentChild from "../../../../../components/Tables/FASParentChild";
import { FilterMain } from "../../../../../Redux/Slice/login/loginSlice";
import {
  BalanceTFormat,
  BalanceTFormatFan,
  BTFormatFan,
} from "../../../../../Redux/Slice/Fas/Financial Statement/BalanceSheet/BalanceSheetSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { Download } from "lucide-react";
import { useTheme } from "../../../../../Themecontext/Themecontext";
import FASparentMultipalChild from "../../../../../components/Tables/FASparentMultipalChild";

export default function T_Format({ selectedIds, ToDate, Fromdate }) {
  const dispatch = useDispatch();

  const { BTFormatdata } = useSelector((state) => state.BalanceSheetSlice);
  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;
  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");
  let YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(BalanceTFormatFan());
    dispatch(
      FilterMain({
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
      }),
    );
    dispatch(
      BalanceTFormat({
        Firm,
        Year: YearId,
        selectedIds: selectedIds || "",
        Fromdate,
        ToDate,
      }),
    );
  }, [dispatch, Firm, YearId, selectedIds, Fromdate, ToDate]);

  const cardStyle = {
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
  };

  const headerStyle = {
    backgroundColor:
      isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
    color: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
    borderTopLeftRadius: "12px",
    borderTopRightRadius: "12px",
    padding: "14px",
    margin: 0,
    position: "relative",
    zIndex: 2,
  };

  const formatAmount = (value) => {
    if (value === null || value === undefined || value === "") return "0.00";
    const num = Number(value);
    return isNaN(num) ? "0.00" : num.toFixed(2);
  };

  const getDrDetailRows =
    BTFormatdata?.LiabilitiesDetail?.map((item, index) => ({
      srNumber: index + 1,
      AcLaieName: item.AcLaieName,
      GroupMstName: item.GroupMstName,
      AcName: item.AcName,
      BalCrAmt: item.BalCrAmt,
    })) || [];

  const getCrDetailRows =
    BTFormatdata?.AssetDetail?.map((item, index) => ({
      srNumber: index + 1,
      AcLaieName: item.AcLaieName,
      GroupMstName: item.GroupMstName,
      AcName: item.AcName,
      BalDrAmt: item.BalDrAmt,
    })) || [];

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Amount", key: "BalCrAmt", align: "right", format: true },
  ];

  const getColumns1 = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Ac Type",
      key: "AcLaieName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Count", key: "count", align: "center" },
    {
      label: "AcGroup Name",
      key: "GroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Account Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Amount", key: "BalDrAmt", align: "right", format: true },
  ];

  const normalize = (v) => (v || "").toLowerCase();

  const orderLiabilitiesAssets = (rows = []) => {
    const liabilities = rows.filter((r) =>
      normalize(r.AcLaieName).includes("liabil"),
    );

    const assets = rows.filter((r) =>
      normalize(r.AcLaieName).includes("asset"),
    );

    return [...liabilities, ...assets];
  };

  const handleDownload1 = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    const formatDate = (dateStr) => {
      if (!dateStr) return "";

      const date = new Date(dateStr);

      return date.toLocaleDateString("en-GB"); // 01/04/2025
    };
    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Balance Sheet", pageWidth / 2, 15, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 18, pageWidth - marginX, 18);

    doc.setFontSize(10);
    doc.setFont(undefined, "normal");

    doc.text(
      `Period : ${formatDate(Fromdate)} - ${formatDate(ToDate)}`,
      pageWidth / 2,
      31,
      {
        align: "center",
      },
    );
    /* ================= FIRM NAME ================= */
    const firmName =
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      DataMain?.Firm_List?.[0]?.GroupName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(String(firmName).trim(), pageWidth / 2, 25, {
      align: "center",
    });

    /* ================= FORMAT FUNCTION ================= */
    const formatIndianAmount = (value) => {
      if (value === null || value === undefined || value === "") return "";
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    /* ================= GROUPING DATA (PARENT / CHILD) ================= */
    const groupData = (details, isAsset = false) => {
      if (!details || details.length === 0) return [];
      const grouped = {};
      details.forEach((item) => {
        const groupName = item.GroupMstName || "Uncategorized";
        if (!grouped[groupName]) {
          grouped[groupName] = {
            groupName: groupName,
            children: [],
            total: 0,
          };
        }
        grouped[groupName].children.push(item);
        grouped[groupName].total +=
          Number(isAsset ? item.BalDrAmt : item.BalCrAmt) || 0;
      });
      return Object.values(grouped);
    };

    const groupedLiabilities = groupData(
      BTFormatdata?.LiabilitiesDetail,
      false,
    );
    const groupedAssets = groupData(BTFormatdata?.AssetDetail, true);

    const liabilitiesRows = [];
    groupedLiabilities.forEach((group) => {
      liabilitiesRows.push({
        type: "parent",
        name: group.groupName.toUpperCase(),
        childAmount: "",
        parentAmount: group.total,
      });
      group.children.forEach((child) => {
        liabilitiesRows.push({
          type: "child",
          name: `   ${child.AcName}`, // indentation for child
          childAmount: Number(child.BalCrAmt) || 0,
          parentAmount: "",
        });
      });
    });

    const assetsRows = [];
    groupedAssets.forEach((group) => {
      assetsRows.push({
        type: "parent",
        name: group.groupName.toUpperCase(),
        childAmount: "",
        parentAmount: group.total,
      });
      group.children.forEach((child) => {
        assetsRows.push({
          type: "child",
          name: `   ${child.AcName}`, // indentation for child
          childAmount: Number(child.BalDrAmt) || 0,
          parentAmount: "",
        });
      });
    });

    /* ================= PREPARING ROWS FOR AUTOTABLE ================= */
    const maxRows = Math.max(liabilitiesRows.length, assetsRows.length);
    const tableRows = [];

    for (let i = 0; i < maxRows; i++) {
      const lRow = liabilitiesRows[i] || {
        name: "",
        childAmount: "",
        parentAmount: "",
      };
      const aRow = assetsRows[i] || {
        name: "",
        childAmount: "",
        parentAmount: "",
      };

      tableRows.push([
        lRow.name,
        lRow.childAmount !== "" ? formatIndianAmount(lRow.childAmount) : "",
        lRow.parentAmount !== "" ? formatIndianAmount(lRow.parentAmount) : "",

        aRow.name,
        aRow.childAmount !== "" ? formatIndianAmount(aRow.childAmount) : "",
        aRow.parentAmount !== "" ? formatIndianAmount(aRow.parentAmount) : "",
      ]);
    }

    /* ================= GRAND TOTAL ================= */
    const liabilityTotal = BTFormatdata?.LiabilitiesSummary?.[0]?.BalCrAmt || 0;
    const assetTotal = BTFormatdata?.AssetSummary?.[0]?.BalDrAmt || 0;

    tableRows.push([
      "TOTAL",
      "",
      formatIndianAmount(liabilityTotal),

      "TOTAL",
      "",
      formatIndianAmount(assetTotal),
    ]);

    /* ================= RENDER TABLE ================= */
    autoTable(doc, {
      startY: 35,
      margin: { left: marginX, right: marginX },

      head: [
        [
          { content: "Liabilities", colSpan: 2, styles: { halign: "left" } },
          { content: "Amount", styles: { halign: "right" } },
          { content: "Assets", colSpan: 2, styles: { halign: "left" } },
          { content: "Amount", styles: { halign: "right" } },
        ],
      ],

      body: tableRows,
      theme: "grid",

      styles: {
        fontSize: 8,
        textColor: [0, 0, 0],
        lineColor: [210, 210, 210],
        lineWidth: 0.1,
        cellPadding: 2,
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [240, 240, 240], // Light grey background like image
        textColor: [0, 0, 0],
        fontStyle: "bold",
        fontSize: 9,
      },

      columnStyles: {
        0: { cellWidth: 80, halign: "left" },
        1: { cellWidth: 25, halign: "right" },
        2: { cellWidth: 30, halign: "right" },
        3: { cellWidth: 80, halign: "left" },
        4: { cellWidth: 25, halign: "right" },
        5: { cellWidth: 30, halign: "right" },
      },

      didParseCell(data) {
        if (data.section !== "body") return;

        const rowIndex = data.row.index;
        const colIndex = data.column.index;

        // Bold Parents for Liabilities (First 3 columns)
        if (colIndex <= 2) {
          const lRow = liabilitiesRows[rowIndex];
          if (lRow && lRow.type === "parent") {
            data.cell.styles.fontStyle = "bold";
          }
        }

        // Bold Parents for Assets (Last 3 columns)
        if (colIndex >= 3) {
          const aRow = assetsRows[rowIndex];
          if (aRow && aRow.type === "parent") {
            data.cell.styles.fontStyle = "bold";
          }
        }

        // Bold and fill TOTAL row
        if (data.row.raw?.[0] === "TOTAL" || data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [240, 240, 240];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i}`, marginX, pageHeight - 5);
    }

    /* ================= SAVE ================= */
    doc.save("T_Format_Statement.pdf");
  };

  const handleDownload = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a4",
    });

    const formatIndianAmount = (value) => {
      const num = Number(value || 0);

      return num.toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 14;

    const formatDate = (dateStr) => {
      if (!dateStr) return "";

      const date = new Date(dateStr);

      return date.toLocaleDateString("en-GB"); // 01/04/2025
    };

    /* ================= TITLE ================= */
    doc.setFontSize(14);
    doc.setFont(undefined, "bold");
    doc.text("Balance Sheet", pageWidth / 2, 12, {
      align: "center",
    });

    doc.setLineWidth(0.5);
    doc.line(marginX, 15, pageWidth - marginX, 15);

    /* ================= FIRM NAME ================= */
    const firmName =
      DataMain?.Firm_List?.[0]?.GroupName ||
      DataMain?.Firm_Dtl?.[0]?.FirmName ||
      "";

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");

    doc.text(String(firmName).trim(), pageWidth / 2, 23, {
      align: "center",
    });

    /* ================= PERIOD ================= */
    doc.setFontSize(10);
    doc.setFont(undefined, "normal");

    doc.text(
      `Period : ${formatDate(Fromdate)} - ${formatDate(ToDate)}`,
      pageWidth / 2,
      30,
      {
        align: "center",
      },
    );

    /* ============= RECEIPT DETAILS (LIABILITIES) ========== */
    let yPos = 38;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Receipt Details", pageWidth / 2, yPos, {
      align: "center",
    });

    yPos += 5;

    const receiptCols = [12, 35, 50, 75, 35];
    const receiptWidth = receiptCols.reduce((a, b) => a + b, 0);
    const receiptLeft = (pageWidth - receiptWidth) / 2;

    const receiptData = orderLiabilitiesAssets(
      BTFormatdata?.LiabilitiesDetail || [],
    );

    let sr = 1;

    const receiptRows = receiptData.map((r) => [
      sr++,
      r.AcLaieName || "",
      r.GroupMstName || "",
      r.AcName || "",
      formatIndianAmount(r.BalCrAmt),
    ]);

    const receiptTotal = BTFormatdata?.LiabilitiesSummary?.[0]?.BalCrAmt || 0;

    receiptRows.push(["", "", "", "TOTAL", formatIndianAmount(receiptTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: {
        left: receiptLeft,
        right: receiptLeft,
      },

      head: [["Sr", "Ac Type", "Ac Group", "Account Name", "Amount"]],

      body: receiptRows,
      theme: "grid",
      showHead: "everyPage",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        fontStyle: "bold",
        valign: "middle",
        textColor: [0, 0, 0],
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        0: {
          halign: "center",
          cellWidth: receiptCols[0],
        },
        1: {
          halign: "left",
          cellWidth: receiptCols[1],
        },
        2: {
          halign: "left",
          cellWidth: receiptCols[2],
        },
        3: {
          halign: "left",
          cellWidth: receiptCols[3],
        },
        4: {
          halign: "right",
          cellWidth: receiptCols[4],
        },
      },

      didParseCell(data) {
        if (data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* =====================================================
      2️⃣ PAYMENT DETAILS (ASSETS)
  ===================================================== */
    doc.addPage();
    yPos = 25;

    doc.setFontSize(12);
    doc.setFont(undefined, "bold");
    doc.text("Payment Details", pageWidth / 2, yPos, {
      align: "center",
    });

    yPos += 5;

    const paymentCols = [12, 35, 50, 75, 35];
    const paymentWidth = paymentCols.reduce((a, b) => a + b, 0);
    const paymentLeft = (pageWidth - paymentWidth) / 2;

    const paymentData = orderLiabilitiesAssets(BTFormatdata?.AssetDetail || []);

    sr = 1;

    const paymentRows = paymentData.map((r) => [
      sr++,
      r.AcLaieName || "",
      r.GroupMstName || "",
      r.AcName || "",
      formatAmount(r.BalDrAmt),
    ]);

    const paymentTotal = paymentData.reduce(
      (sum, r) => sum + Number(r.BalDrAmt || 0),
      0,
    );

    paymentRows.push(["", "", "", "TOTAL", formatAmount(paymentTotal)]);

    autoTable(doc, {
      startY: yPos,
      margin: {
        left: paymentLeft,
        right: paymentLeft,
      },

      head: [["Sr", "Ac Type", "Ac Group", "Account Name", "Amount"]],

      body: paymentRows,
      theme: "grid",
      showHead: "everyPage",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        fontStyle: "bold", // add this line
        valign: "middle",
        textColor: [0, 0, 0],
      },

      headStyles: {
        fillColor: [220, 220, 220],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
      },

      columnStyles: {
        0: {
          halign: "center",
          cellWidth: paymentCols[0],
        },
        1: {
          halign: "left",
          cellWidth: paymentCols[1],
        },
        2: {
          halign: "left",
          cellWidth: paymentCols[2],
        },
        3: {
          halign: "left",
          cellWidth: paymentCols[3],
        },
        4: {
          halign: "right",
          cellWidth: paymentCols[4],
        },
      },
      didParseCell(data) {
        if (data.row.raw?.[3] === "TOTAL") {
          data.cell.styles.fontStyle = "bold";
          data.cell.styles.fillColor = [235, 235, 235];
        }
      },
    });

    /* ================= PAGE NUMBER ================= */
    const pageCount = doc.internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.text(`Page ${i}`, marginX, pageHeight - 5);
    }

    doc.save("T_Format_Statement.pdf");
  };
  if (BTFormatdata === "no" || BTFormatdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "10px", // buttons ke beech gap
          marginBottom: "10px",
          width: "100%",
        }}
      >
        <button
          onClick={handleDownload}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Format 1
        </button>

        <button
          onClick={handleDownload1}
          className="common-hover-btn"
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6,
            color:
              isdark === "light" ? iscolour?.Colour11 : iscolourDark?.Colour12,
            border: "none",
            padding: "10px 16px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "14px",
            height: "44px",
          }}
        >
          <Download size={16} />
          Format 2
        </button>
      </div>
      <Row className="  ">
        <Col xl={12} lg={12}>
          <div>
            <div style={cardStyle}>
              <div style={headerStyle}>
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    wordBreak: "break-word",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  LIABILITIES
                </h2>
              </div>

              {/* <FASparentMultipalChild
                data={getDrDetailRows}
                columns={getColumns}
                externalTotals={{
                  Amount: BTFormatdata?.LiabilitiesSummary?.[0]?.BalCrAmt || 0,
                }}
              /> */}

              <FASparentMultipalChild
                data={getDrDetailRows}
                columns={getColumns}
                externalTotals={BTFormatdata?.LiabilitiesSummary?.[0] || {}}
              />
            </div>
          </div>
        </Col>

        <Col xl={12} lg={12}>
          <div style={{ marginTop: "20px" }}>
            <div style={cardStyle}>
              <div style={headerStyle}>
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour11,
                    fontWeight: "600",
                  }}
                >
                  ASSETS
                </h2>
              </div>

              {/* <FASparentMultipalChild
                data={getCrDetailRows}
                columns={getColumns1}
                externalTotals={{
                  Amount: BTFormatdata?.AssetSummary?.[0]?.BalDrAmt || 0,
                }}
              /> */}

              <FASparentMultipalChild
                data={getCrDetailRows}
                columns={getColumns1}
                externalTotals={BTFormatdata?.AssetSummary?.[0] || {}}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
